export function formatViews(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + ' M';
  if (n >= 1_000) return (n / 1_000).toFixed(1) + ' K';
  return String(n);
}

type Translator = (key: string, params?: Record<string, unknown>) => string;

/** « il y a 3 h », « hier », « il y a 5 j » — dans la langue du site (repli quand le serveur n'envoie pas d'affichage structuré). */
export function timeAgo(iso: string, t: Translator): string {
  try {
    const diffMs = Date.now() - new Date(iso).getTime();
    const diffH = Math.floor(diffMs / (1000 * 60 * 60));
    if (diffH < 1) return t('NOTIF.AGO.NOW');
    if (diffH < 24) return t('NOTIF.AGO.HOUR', { n: diffH });
    if (diffH < 48) return t('TIME_SHORT.YESTERDAY');
    return t('NOTIF.AGO.DAY', { n: Math.floor(diffH / 24) });
  } catch {
    return '';
  }
}

/**
 * Temps relatif d'ajout (« 4 jours », « 1 mois ») d'après l'information structurée renvoyée par le Middleware
 * (unité, nombre, heure), dans la langue du site. Chaîne vide si l'unité est absente.
 */
export function relativeTimeLabel(
  unit: 'time' | 'day' | 'week' | 'month' | 'year' | undefined,
  count: number | undefined,
  time: string | undefined,
  t: Translator,
): string {
  if (!unit) return '';
  if (unit === 'time') return time ? t('TIME_SHORT.AT_TIME', { time }) : '';
  if (count === undefined) return '';
  return t(`TIME_SHORT.${unit.toUpperCase()}_${count === 1 ? 'ONE' : 'MANY'}`, { count });
}

export function isNew(iso: string): boolean {
  try {
    return Date.now() - new Date(iso).getTime() < 28 * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
}
